import * as Blockly from 'blockly/core';
import 'blockly/python';
import createCustomThresholdFields from "./strata_custom_threshold_fields";
import {getAllowedOutputs} from "./strata_compatibility_checks";
import createInfoButton from './strata_additional_info'

Blockly.Blocks['strata_env_indicator'] = {
    init: function () {
        let indicatorInput = this.appendDummyInput()
            .setAlign(Blockly.ALIGN_LEFT)
            .appendField("Environmental Indicator   ")
            .appendField(new Blockly.FieldDropdown([
                ["Drought (agricultural)", "agr_dr"],
                ["Drought (meteorological)", "met_dr"],
                ["Heatwave", "heatwave"],
                ["Flood Likelihood", "fl_likelihood"],
                ["Coastal Inundation Risk", "inund_risk"],
                // ["Flood Risk", "fl_risk"],
                // ["TC Wind Risk", "tc_risk"],
                // ["Tc Surge Risk", "tc_surge"] ,
                ["Deforestation", "deforestation"],
                ["Land Degradation", "degradation"],
                // ["Fishing Rate", "fish_rate"]
            ]), "indicator_selection");
        createInfoButton(indicatorInput, this)
        createCustomThresholdFields(this);

        this.setPreviousStatement(true, 'strata_environment_indicator');
        this.setNextStatement(true, getAllowedOutputs('environmental_indicators'));
        this.setStyle('environment_indicator')
        this.setTooltip("");
        this.setHelpUrl("");
    }
}